import { toHandlers as _toHandlers, mergeProps as _mergeProps, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-62aa27d3")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")

  return (_openBlock(), _createBlock(_component_DatePicker, {
    modelValue: _ctx.picked,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.picked = $event)),
    masks: _ctx.masks,
    locale: _ctx.$store.state.PageData.LanguageId,
    columns: 2,
    placeholder: _ctx.$t(_ctx.filterData?.emptyValue),
    "min-date": _ctx.dateFrom,
    "is-range": true,
    popover: {visibility: 'click'},
    color: "red"
  }, {
    default: _withId(({ inputValue, inputEvents, togglePopover}) => [
      _createVNode("input", _mergeProps({
        class: ["input-datepicker w-full border-2 border-htz-grey min-h-60 px-4 cursor-pointer transition-all duration-300 ease-in-out hover:border-htz-red", _ctx.classList],
        value: _ctx.returnDateValue(inputValue),
        placeholder: _ctx.$t(_ctx.filterData?.emptyValue)
      }, _toHandlers(inputEvents.start || inputEvents.end), { onClick: togglePopover }), null, 16, ["value", "placeholder", "onClick"]),
      _createVNode("button", {
        type: "button",
        class: "datepicker-clear-btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetDates && _ctx.resetDates(...args)))
      }, " × ")
    ]),
    _: 1
  }, 8, ["modelValue", "masks", "locale", "placeholder", "min-date"]))
})